module.exports = __webpack_public_path__ + "img/television.b50a05d3.png";